const FbIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_14744_135881)">
            <path d="M21.8718 0.905624H2.12989C1.45369 0.905624 0.905518 1.4538 0.905518 2.13V21.8719C0.905518 22.5481 1.45369 23.0962 2.12989 23.0962H21.8718C22.548 23.0962 23.0961 22.5481 23.0961 21.8719V2.13C23.0961 1.4538 22.548 0.905624 21.8718 0.905624Z" fill="#3D5A98" />
            <path d="M16.215 23.0944V14.5012H19.0987L19.53 11.1525H16.215V9.015C16.215 8.04562 16.485 7.38375 17.8743 7.38375H19.6481V4.38375C18.7892 4.29439 17.926 4.25183 17.0625 4.25625C14.5087 4.25625 12.75 5.8125 12.75 8.68312V11.1525H9.86621V14.5012H12.75V23.0944H16.215Z" fill="white" />
        </g>
        <defs>
            <clipPath id="clip0_14744_135881">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default FbIcon;